import React from 'react';
import projectThumb from '../../assets/images/s2.jpg';

function ProjectHomeOne({ className }) {
    return (
        <>
            <section id={`pricing`} className={`appie-project-area pt-100 pb-100 ${className || ''}`}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div
                                className="appie-project-box wow animated slideInUp"
                                data-wow-duration="1000ms"
                                data-wow-delay="0ms"
                            >
                                <div className="row">
                                    <div className="col-lg-6">
                                        <div className="appie-project-content">
                                            <h3 className="title">
                                                Start using ATMS - Agan Integration
                                            </h3>
                                            <h3 className="title text-dark">
                                                29$/Month
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                                <div className="appie-project-thumb">
                                    <img src={projectThumb} alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default ProjectHomeOne;
